module.exports = __webpack_public_path__ + "img/Oval@2x(1).a560c692.png";